module.exports = __webpack_public_path__ + "static/media/off.df6adba6.svg";